import {
  Flex,
  FlexProps,
  Icon,
  SecondaryButton,
  Typo,
  useModal,
  xsBumps,
  xxsBumps,
} from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback, useMemo } from 'react'
import { useNavigate } from 'react-router'

import { canCancel } from '../../../../domain'
import {
  TKey,
  useWriskTranslation,
} from '../../../../infrastructure/internationalisation'
import { CancellationNotAllowedModal } from '../../../organisms/cancellation'
import { useProduct } from '../../productContext'
import { PolicyPath } from '../PolicyPath'
import { usePolicy } from '../PolicyProvider'
import { PolicySidebarPricing } from '../pricing'

const tKey = TKey('components.policy-sidebar')

export const PolicySidebar: FunctionComponent<FlexProps> = (props) => {
  const navigate = useNavigate()

  const { t } = useWriskTranslation()

  const { product } = useProduct()
  const { policy } = usePolicy()
  const { show } = useModal()
  const { cancellation } = product

  const handleCancel = useCallback(() => {
    if (cancellation?.type === 'CustomerCare') {
      show({
        content: <CancellationNotAllowedModal />,
      })
    } else {
      navigate(PolicyPath.CANCEL)
    }
  }, [navigate, show, product])

  const showCancelButton = useMemo(() => {
    return (
      cancellation?.type === 'CustomerCare' || canCancel(policy, product.cancellation)
    )
  }, [policy, product])

  const benefits = t(tKey('benefits'), {
    returnObjects: true,
    defaultValue: [],
  }) as string[]

  const benefitsSection = benefits.map((benefit, index) => (
    <Flex justifyContent='flex-start' width={1} my={xxsBumps} key={index}>
      <Icon icon='tick' size='small' mr={xsBumps} />
      <Typo typoSize='sm'>{benefit}</Typo>
    </Flex>
  ))

  return (
    <Flex width={1} flexDirection='column' variant='raised' {...props}>
      <PolicySidebarPricing
        policy={policy}
        product={product}
        borderBottomWidth={1}
        width={1}
      />
      {showCancelButton && (
        <Flex flexDirection='column' width={1} px={5} pt={5}>
          <SecondaryButton
            width={1}
            onClick={handleCancel}
            data-testid='button-cancel-policy'
          >
            {t(tKey('actions.cancel'))}
          </SecondaryButton>
        </Flex>
      )}
      {Boolean(benefitsSection.length) && (
        <Flex flexDirection='column' width={1} p={5}>
          {benefitsSection}
        </Flex>
      )}
    </Flex>
  )
}
